import { module } from "angular";
import { map } from "rxjs/operators";

import type { Observable } from "rxjs";

import type { IHttpService } from "App/Modules/Services";

import type { IActiveAlarmsInfo, IAlarm, IAlarmSlim, IResponse } from "../../Models";
import type { IAlarmsRepository } from "./IAlarmsRepository";

import AlarmHandlingRepository from "../AlarmHandling/AlarmHandlingRepository";

export default class AlarmsRepository implements IAlarmsRepository {
    public static $inject = ["mmHttpService"];

    constructor(private readonly httpService: IHttpService) {}

    public getAlarm(alarmId: string): Observable<IResponse<IAlarm>> {
        return this.httpService.get<IAlarm>(`alarms/${alarmId}`).pipe(
            map((response: IResponse<IAlarm>) => {
                if (!response.data) {
                    return response;
                }

                AlarmHandlingRepository.enhanceAlarmHandling(response.data.alarmHandling);

                return response;
            }),
        );
    }

    public getActive(): Observable<IResponse<IActiveAlarmsInfo>> {
        return this.httpService.get<IActiveAlarmsInfo>("alarms");
    }

    public getHandled(): Observable<IResponse<IAlarmSlim[]>> {
        return this.httpService.get<IAlarmSlim[]>("alarms/handled");
    }

    public getNextAlarmInQueue(): Observable<IResponse<IAlarm>> {
        return this.httpService.get<IAlarm>("alarms/nextAlarm").pipe(
            map((response: IResponse<IAlarm>) => {
                if (!response.data) {
                    return response;
                }

                AlarmHandlingRepository.enhanceAlarmHandling(response.data.alarmHandling);

                return response;
            }),
        );
    }

    public getByTimeSpanSupervision(params: any): Observable<IResponse<IAlarm[]>> {
        return this.httpService.get<IAlarm[]>("alarms/supervision", params);
    }

    public getByTimeSpanSupervisionTotals(params: any): Observable<IResponse<IAlarm[]>> {
        return this.httpService.get<IAlarm[]>("alarms/supervisionTotal", params);
    }
}

module("mmRepositories").service("mmAlarmsRepository", AlarmsRepository);
